<div class="text-center mt-8 mb-8 md:mb-16">
  <h2 class="inner-title-style inline-block te-text-gradient-drive" [innerHTML]="title"></h2>
  <p
    *ngIf="subtitle"
    class="font-sans text-base font-normal leading-10 mt-5 md:w-1/2 mx-auto"
    [innerHTML]="subtitle"
  ></p>
</div>
